import React from "react";
import "../styles/ReturnsPage.css";

const ReturnsPage = () => {
  return (
    <div className="returns-page">
      <section className="returns-hero">
        <h1>Returns & Refund Policy</h1>
        <p>Your satisfaction is our top priority 🚴‍♂️</p>
      </section>

      <section className="returns-content">
        <h2>Return Eligibility</h2>
        <p>
          We accept returns within <strong>7 days</strong> of delivery. The item must
          be unused, in original packaging, and in the same condition as received.
        </p>

        <h2>Non-Returnable Items</h2>
        <ul>
          <li>Customized or assembled bicycles</li>
          <li>Used accessories or parts</li>
          <li>Products damaged after delivery</li>
          <li>Gift cards or promotional items</li>
        </ul>

        <h2>Return Process</h2>
        <ol>
          <li>
            Contact our support team at{" "}
            <a href="mailto:support@sacmtb.com">support@sacmtb.com</a> with your
            order ID and reason for return.
          </li>
          <li>
            Our team will verify your request and share return shipping details.
          </li>
          <li>
            Once we receive the product, it will be inspected and processed within{" "}
            <strong>3–5 business days</strong>.
          </li>
        </ol>

        <h2>Refunds</h2>
        <p>
          Approved refunds will be credited back to your original payment method
          within <strong>5–7 working days</strong>. Shipping charges are
          non-refundable.
        </p>

        <h2>Exchange Policy</h2>
        <p>
          Exchanges are only allowed for defective or damaged items. Contact our
          team within 48 hours of delivery for assistance.
        </p>

        <div className="returns-support">
          <p>
            Need help? Contact our support team via email or WhatsApp at{" "}
            <strong>+91 6396353776</strong>.
          </p>
        </div>
      </section>
    </div>
  );
};

export default ReturnsPage;
